var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.message.info || _vm.message.link
    ? _c("div", { staticClass: "marketing-message" }, [
        _c("div", { staticClass: "message-container" }, [
          _c("p", { staticClass: "message" }, [
            _c("span", { staticClass: "message-info" }, [
              _vm._v(_vm._s(_vm.message.info))
            ]),
            _vm._v(" "),
            _vm.message.link
              ? _c(
                  "a",
                  {
                    staticClass: "marketing-message-link",
                    attrs: { href: _vm.message.href, target: "_blank" }
                  },
                  [_vm._v("\n        " + _vm._s(_vm.message.link) + "\n      ")]
                )
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c(
          "button",
          { staticClass: "close-icon", on: { click: _vm.close } },
          [
            _c("NsIcon", {
              attrs: { "icon-name": "icon-close-24", size: "custom" }
            })
          ],
          1
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }